import ResponseCodes from "../../../../src/mdx/api/response-codes.mdx";
import * as React from 'react';
export default {
  ResponseCodes,
  React
};